<div class="item-container d-flex flex-column h-100">
    <div class="item-header ">
        <h6 class="text-center mb-0">{{"Course Information" | translate}}</h6>
        <div class="edit-icons cursor-pointer" mat-dialog-close>
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content">
        <div class="course-box d-flex py-2 py-sm-3">
            <div class="course-img" [appBackgroundImg]="courseData.img">
            </div>
            <div class="mt-2 mt-sm-0 ps-sm-3 ps-lg-4 d-flex flex-column justify-content-center">
                <h6 class="mb-1">{{courseData.tit}}</h6>
                 <p class="mb-1">{{courseData.dep}}</p>
                 <div class="badge-icon success-badge" *ngIf="courseData.per==100">{{"STATUS.COMPLETED" | translate}}</div>

            </div>
        </div>
        <div class="row b-class b-top py-2">
            <div class="col-6 item-txt">{{"COURSE.EXAMATTENDED"|translate}}</div>
            <div class="col-6">
            <div class="badge-icon success-badge" *ngIf="courseData.is_att==1">Attended</div>
            <div class="badge-icon failure-badge" *ngIf="courseData.is_att==0">No</div>
        </div>
            
        </div>
        <div class="row b-class py-2">
            <div class="col-6 item-txt">{{"COURSE.EXAMRESULT"|translate}}</div>
            <div class="col-6"><div class="badge-icon success-badge" *ngIf="courseData.is_p==1">Passed</div>
            <div class="badge-icon failure-badge" *ngIf="courseData.is_p==0 && courseData.is_att==1">Failed</div>
            </div>
        </div>
        <div class="row b-class py-2">
            <div class="col-6 item-txt ">{{"COURSE.TOTALPASSEDCOUNT"|translate}}</div>
            <div class="col-6">{{courseData.ps_c}}</div>
        </div>
        <div class="row b-class py-2">
            <div class="col-6 item-txt ">{{"COURSE.TOTALREATTEMPTCOUNT" | translate}}</div>
            <div class="col-6">{{courseData.r_att }}</div>
        </div>
        <div class="row b-class py-2">
            <div class="col-6 item-txt ">{{"COURSE.LASTTIMEEXAMATTENDED"|translate}}</div>
            <div class="col-6">{{courseData.la_up |  dates : 'date_time' }}</div>
        </div>
        <div class="row b-class py-2">
            <div class="col-6 item-txt ">{{"COURSE.CERTIFICATEEXPIRESIN"|translate}}</div>
            <div class="col-6"> {{courseData.c_et | dates}}</div>
        </div>
        <div class="row b-class py-2">
            <div class="col-6 item-txt ">{{"COURSE.TIMESPENT"|translate}}</div>
            <div class="col-6">{{convertSecondsToHoursMinutesSeconds(courseData.sp_ti)}}</div>
        </div>       
        <div class="row b-class py-2">
            <div class="col-6 item-txt ">{{"Employee Signature"|translate}}</div>
            <div class="col-6">
                <img class="sign-img" *ngIf="courseData.sign" [src]="checkUrl(courseData.sign)" alt="">
            </div>
        </div>       
    </div>
</div>
